<!-- eslint-disable prettier/prettier -->
<!--
  Rekryteringsbyrå: extra samtyckesklausul som namnger det mottagande
  kundföretaget (Bolag B) för en enskild annons. Renderas av CustomerGdpr när
  annonsens mottagare är satt (/position/recipientMode === "client",
  /position/recipientCompany, ANSKNI-99/100). Egen komponent — fristående från
  390/393-medlemsföretags-specialaren (CustomerGdpRrekryteringslots.vue).
-->
<template>
  <div class="flex flex-col gap-2 my-4">
    <h2 class="text-lg font-bold">Mottagare – utlämning till kundföretag</h2>
    <p class="">
      Denna annons hanteras
      <template v-if="props?.company?.DisplayName?.data"
        >av {{ props?.company?.DisplayName?.data }}</template
      >
      på uppdrag av ett kundföretag. Genom att godkänna samtycker Du till att de
      personuppgifter Du lämnar i Din ansökan kan komma att lämnas ut till
      följande kundföretag, som självständigt personuppgiftsansvarig, för beslut
      i rekryteringsärendet:
    </p>
    <p class="font-semibold">{{ props.recipientCompany }}</p>
  </div>
</template>
<script setup lang="ts">
import { Profile } from "@/models/Profile";
import { defineProps } from "vue";

const props = defineProps({
  company: {
    type: Profile,
    required: true,
  },
  recipientCompany: {
    type: String,
    required: true,
  },
});
</script>
